const Header = () => {
    return (
        <img src="./images/logo.svg" alt="logo splitter" />
    )
}

export default Header;